<template>
  <div class="section">
    <div class="section-title">
      <base-section-title title="招标概况">
        <template v-slot:right-tool>
          <slot name="title"></slot>
        </template>
      </base-section-title>
    </div>
    <div class="section-content">
      <el-form label-width="100px" class="detail-form" label-suffix="：">
        <el-form-item label="采购单位">
          <span>{{ inviteBidForm.ownerCompanyName || ' - ' }}</span>
        </el-form-item>
        <el-form-item label="招标编号">
          <span>{{ inviteBidForm.orderCode || ' - ' }}</span>
        </el-form-item>
        <el-form-item
          v-if="
            inviteBidForm.entrustType === bidOrganizationModeDict.ENTRUST.value
          "
          label="代理单位"
        >
          <span>{{ inviteBidForm.purchaseCompanyName || ' - ' }}</span>
        </el-form-item>
        <el-form-item label="响应时间">
          <span>
            {{
              inviteBidForm.signUpStartTime
                | getNormMinuteRangeFilter(inviteBidForm.signUpEndTime)
            }}
          </span>
        </el-form-item>
        <el-form-item label="开标时间">
          <span>{{ inviteBidForm.openTime | getNormMinuteFilter }}</span>
        </el-form-item>
        <el-form-item label="招标地点">
          <span>
            {{
              inviteBidForm.province
                ? `${inviteBidForm.province} - ${inviteBidForm.city} - ${inviteBidForm.area}`
                : '-'
            }}
          </span>
        </el-form-item>
        <el-form-item label="详细地址">
          <span>{{ inviteBidForm.detailAddress || ' - ' }}</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

import { bidOrganizationModeDict } from '@/dictionary/project/bid'

export default {
  name: 'InviteBidInfo',

  components: {
    BaseSectionTitle
  },

  props: {
    inviteBidForm: {
      type: Object,
      default: () => {},
      required: true
    }
  },

  data() {
    return {
      bidOrganizationModeDict
    }
  }
}
</script>
